var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningBalloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.162,
    height: 29.2,
    viewBox: "0 0 29.162 29.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.162,
    height: 29.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_246",
    "data-name": "Grupo 246",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.114,15.7a2.037,2.037,0,0,1,.048-.245V13.745c-.073-.553-.124-1.11-.224-1.657a14.377,14.377,0,0,0-6.314-9.661A14.02,14.02,0,0,0,15.713.047,1.63,1.63,0,0,1,15.494,0H13.671c-.543.075-1.089.138-1.63.226A14.567,14.567,0,0,0,.355,11.419a14.262,14.262,0,0,0,3.358,12.89A14.092,14.092,0,0,0,12.884,29.1l.844.1h1.709c.544-.073,1.09-.132,1.631-.222a13.945,13.945,0,0,0,4.638-1.647.551.551,0,0,1,.5-.049c1.837.63,3.678,1.249,5.518,1.871a.336.336,0,0,1,.07.045h.456a1.369,1.369,0,0,0,.911-.913v-.456q-.681-1.986-1.361-3.972c-.19-.555-.385-1.109-.558-1.67a.553.553,0,0,1,.03-.39,14.625,14.625,0,0,0,1.841-6.1m-4.224,6.68c.415,1.181.807,2.37,1.208,3.556.027.079.05.16.09.292-1.228-.415-2.415-.782-3.574-1.222a1.844,1.844,0,0,0-1.763.178A12.313,12.313,0,1,1,26.64,12.163a12.16,12.16,0,0,1-1.606,8.92,1.416,1.416,0,0,0-.144,1.3",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.805,90.588a1.1,1.1,0,0,0-1.254-.553,1.123,1.123,0,0,0-.869,1.124c0,1.434,0,2.868,0,4.3s0,2.887,0,4.331a1.137,1.137,0,1,0,2.274,0q.007-4.316,0-8.633a1.315,1.315,0,0,0-.146-.569",
    transform: "translate(-163.236 -83.156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.832,264.009a1.14,1.14,0,1,0,1.149,1.129,1.14,1.14,0,0,0-1.149-1.129",
    transform: "translate(-163.26 -243.933)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBalloon);
export default __webpack_public_path__ + "static/media/warning-balloon.12cf2964711a3bee6eb4507d74a2dea9.svg";
export { ForwardRef as ReactComponent };